/**
 * Minimal loyalty hook used by the AppShell pill. Ticket superall-shell-03
 * extends this with tier-progress + history.
 */

import * as React from "react";

import { PLATFORM_API, apiGetJSON } from "../lib/api";
import { useAuth } from "../providers/AuthProvider";

export interface LoyaltySummary {
  points: number;
  tier: string;
  expiringPoints: number;
  expiringAt: string | null;
  enrolled?: boolean;
}

interface UseLoyaltyBalanceResult {
  data: LoyaltySummary | null;
  loading: boolean;
  error: Error | null;
}

export function useLoyaltyBalance(): UseLoyaltyBalanceResult {
  const { token } = useAuth();
  const [data, setData] = React.useState<LoyaltySummary | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<Error | null>(null);

  React.useEffect(() => {
    if (!token) {
      setData(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    apiGetJSON<LoyaltySummary>(`${PLATFORM_API}/loyalty/balance`)
      .then((next) => {
        if (cancelled) return;
        setData(next);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err instanceof Error ? err : new Error(String(err)));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return { data, loading, error };
}
